export const colorByPreset = {
  id: 'root',
  data: {
    activeByPreset: {
      values: [
        {
          provider: 'id:root',
          property: 'hasPresetSelectHeader',
        },
        {
          provider: 'id:preselect-header-select',
          property: 'toggleFilter',
          startWith: ['0'],
        },
      ],
      transform: function ([hasPresetSelectHeader, selectedHeaderPreset]: [
        boolean,
        string,
      ]) {
        if (hasPresetSelectHeader && selectedHeaderPreset?.[0] === '1') {
          return true;
        }
        return false;
      }.toString(),
    },
    colorByPreset: {
      provider: 'id:root',
      property: 'activeByPreset',
      transform: function (activeByPreset: boolean) {
        if (activeByPreset) {
          return 'rgba(255, 213, 33, 1)';
        }
        return 'rgba(232, 232, 232, 0.6)';
      }.toString(),
    },
    backgroundColor: {
      provider: 'id:root',
      property: 'colorByPreset',
    },
  },
};
